/**
 * Centralized auth token management.
 * All token read/write operations go through this module
 * to avoid scattered localStorage access across the codebase.
 */

const TOKEN_KEY = "cmes_token";
const USER_KEY = "cmes_user";
const ACTIVITY_KEY = "cmes_last_activity";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
export const setStoredUser = (user) => localStorage.setItem(USER_KEY, JSON.stringify(user));
export const removeStoredUser = () => localStorage.removeItem(USER_KEY);

export const getLastActivity = () => parseInt(localStorage.getItem(ACTIVITY_KEY) || "0", 10);
export const setLastActivity = () => localStorage.setItem(ACTIVITY_KEY, Date.now().toString());
export const removeLastActivity = () => localStorage.removeItem(ACTIVITY_KEY);

export const clearSession = () => {
  removeToken();
  removeStoredUser();
  removeLastActivity();
};

export const getAuthHeaders = () => ({
  Authorization: `Bearer ${getToken()}`
});
